module.exports = __webpack_public_path__ + "img/bosque2.0653f894.jpg";